import { IScore } from '../api/models/score/score.types';

export enum EScoreActionType {
  GET = 'SCORE_GET',
  GET_SUCCESS = 'SCORE_GET_SUCCESS',
}

export interface IGetScoreAction {
  type: EScoreActionType.GET;
  payload: string;
}

export const getScoreAction = (accountId: string): IGetScoreAction => ({
  type: EScoreActionType.GET,
  payload: accountId,
});

export interface IGetScoreSuccessAction {
  type: EScoreActionType.GET_SUCCESS;
  payload: IScore;
}

export const getScoreSuccessAction = (
  score: IScore
): IGetScoreSuccessAction => ({
  type: EScoreActionType.GET_SUCCESS,
  payload: score,
});

export type IScoreAction = IGetScoreAction | IGetScoreSuccessAction;
